import React from 'react';
import { Link } from 'react-router-dom';
// Importação dos componentes padronizados
import HeaderTwo from "../header/HeaderTwo";
import FooterTwo from "../footer/FooterTwo";
import Breadcrumb from "../../inner/Breadcrumb"; 

function ServiceDetailTemplate({ 
    title, 
    mainImage, 
    description1, 
    description2, 
    cards, 
    processSteps, 
    benefitTitle, 
    benefitDisc, 
    benefits 
}) {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Detalhes do Serviço' }
    ];

    return (
        <div>
            {/* Header Padronizado com caminhos absolutos para a logo */}
            <HeaderTwo />
            
            <Breadcrumb title={title} breadcrumbs={breadcrumbs} />

            <div className="rts-service-details-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-md-12 col-sm-12 col-12">
                            {/* Conteúdo Principal */}
                            <div className="service-detials-step-1">
                                <div className="thumbnail">
                                    {/* O mainImage deve vir com "/" do arquivo pai (ex: /assets/...) */}
                                    <img src={mainImage} alt={title} />
                                </div>
                                <h4 className="title">{title}</h4>
                                <p className="disc">{description1}</p>
                                <p className="disc">{description2}</p>
                                
                                <div className="row g-5 mt--30 mb--40">
                                    {cards.map((card, index) => (
                                        <div className="col-lg-6" key={index}>
                                            <div className="service-details-card">
                                                <div className="thumbnail">
                                                    {/* O card.icon também deve vir com "/" do arquivo pai */}
                                                    <img src={card.icon} alt="" className="icon" />
                                                </div>
                                                <div className="details">
                                                    <h6 className="title">{card.title}</h6>
                                                    <p className="disc">{card.disc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Etapas do Processo */}
                            <div className="service-detials-step-2 mt--40">
                                <h4 className="title">Processo em Etapas</h4>
                                <div className="row mb--40 g-5">
                                    {processSteps.map((step, index) => (
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
                                            <div className="single-service-step text-center">
                                                <p className="step">0{index + 1}</p>
                                                <h6 className="title">{step.title}</h6>
                                                <p className="disc">{step.disc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Benefícios */}
                            <div className="service-detials-step-3 mt--70">
                                <div className="row g-5 align-items-center">
                                    <div className="col-xl-6 col-lg-12">
                                        <div className="thumbnail sm-thumb-service">
                                            {/* AJUSTADO: Adicionada a "/" no início do src */}
                                            <img src="/assets/images/service/sm-01.jpg" alt="Benefícios GB Partner" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12">
                                        <h4 className="title">{benefitTitle}</h4>
                                        <p className="disc">{benefitDisc}</p>
                                        {benefits.map((item, index) => (
                                            <div className="single-banifits" key={index}>
                                                <i className="far fa-check-circle" />
                                                <span>{item}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar fixa (Categorias) */}
                        <div className="col-xl-4 col-md-12 col-sm-12 col-12 mt_lg--60 pl--50">
                            <div className="rts-single-wized Categories service">
                                <div className="wized-header">
                                    <h5 className="title">Categorias</h5>
                                </div>
                                <div className="wized-body">
                                    <ul className="single-categories">
                                        <li><Link to="/servicos/credito-empresarial">Crédito Empresarial <i className="far fa-long-arrow-right" /></Link></li>
                                        <li><Link to="/servicos/agro">Agro <i className="far fa-long-arrow-right" /></Link></li>
                                        <li><Link to="/servicos/seguros">Seguros <i className="far fa-long-arrow-right" /></Link></li>
                                        <li><Link to="/servicos/credito-carbono">Crédito de Carbono <i className="far fa-long-arrow-right" /></Link></li>
                                        <li><Link to="/servicos/inteligencia-mercado">Inteligência de Mercado <i className="far fa-long-arrow-right" /></Link></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Widget de Contato Rápido */}
                            <div className="rts-single-wized contact service">
                                <div className="wized-body">
                                    <h5 className="title">Precisa de ajuda especializada?</h5>
                                    <Link className="rts-btn btn-primary" to="/Contato">Fale Conosco</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Padronizado */}
            <FooterTwo />
        </div>
    );
}

export default ServiceDetailTemplate;